module.exports = __webpack_public_path__ + "img/aero_measuring.33a3438e.png";